<template>
  <div class="h5-container">
    <!-- 顶部导航栏 -->
    <van-nav-bar
        class="top-bar"
        title="修改密码"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>

    <!-- 密码修改表单 -->
    <div class="form-wrap">
      <van-form @submit="onSubmit" ref="modifyPwdForm">
        <!-- 手机号：只读回显，不可编辑 -->
        <van-field
            v-model="formData.phoneNumber"
            name="phoneNumber"
            label="手机号"
            placeholder="请输入手机号"
            readonly
            :rules="[{ required: true, message: '手机号不能为空' }, { pattern: mobileReg, message: '手机号格式错误' }]"
        />

        <!-- 新密码：blur绑定长度校验 -->
        <van-field
            v-model="formData.newPassword"
            name="newPassword"
            label="新密码"
            type="password"
            placeholder="请输入6-16位密码"
            clearable
            maxlength="16"
            @blur="checkPwdLength"
            :rules="[{ required: true, message: '请输入新密码', trigger: 'blur' }]"
        />

        <!-- 确认新密码：blur绑定一致性校验 -->
        <van-field
            v-model="formData.confirmPassword"
            name="confirmPassword"
            label="确认新密码"
            type="password"
            placeholder="请再次输入新密码"
            clearable
            maxlength="16"
            @blur="checkPwdSame"
            :rules="[{ required: true, message: '请确认新密码', trigger: 'blur' }]"
        />
        <div class="pwd-tips">修改密码成功后需要重新登录</div>

        <!-- 保存按钮 -->
        <van-button
            class="submit-btn"
            round
            block
            type="info"
            native-type="submit"
            :loading="isSubmitting"
            style="margin-top: 24px;"
        >
          保存
        </van-button>
      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {Dialog, Toast} from "vant";
import {memberInformation} from "@/api/mine";
import {updatePassword} from "@/api/sales";

export default {
  name: "ModifyPwdPage",
  data() {
    return {
      formData: {
        phoneNumber: "", // 手机号（只读回显）
        newPassword: "", // 新密码
        confirmPassword: "" // 确认新密码
      },
      isSubmitting: false, // 防止重复提交
      mobileReg: /^1[3-9]\d{9}$/, // 手机号正则校验
      isPwdLegal: false // 标记新密码是否合法，用于确认密码校验前置判断
    };
  },
  created() {
    this.getUserPhone();
  },
  methods: {
    // 新密码失焦校验：6-16位（去空格）
    checkPwdLength() {
      const trimNewPwd = this.formData.newPassword.trim();
      // 长度6-16位则合法，否则提示
      if (trimNewPwd.length >= 6 && trimNewPwd.length <= 16) {
        this.isPwdLegal = true;
        return true;
      }
      this.isPwdLegal = false;
      Toast("新密码为6-16位字符，请重新输入");
      return false;
    },

    // 确认密码失焦校验：与新密码一致（前置判断新密码是否合法）
    checkPwdSame() {
      // 先判断新密码是否合法，不合法则直接返回
      if (!this.isPwdLegal) {
        Toast("请先输入合法的新密码");
        return false;
      }
      const trimConfirmPwd = this.formData.confirmPassword.trim();
      const trimNewPwd = this.formData.newPassword.trim();
      // 对比密码是否一致
      if (trimConfirmPwd === trimNewPwd) {
        return true;
      }
      Toast("两次输入的密码不一致，请重新输入");
      return false;
    },

    // 获取用户手机号（仅回显）
    async getUserPhone() {
      try {
        const res = await memberInformation();
        if (res.code === 200 && res.data) {
          this.formData.phoneNumber = res.data.userName || res.data.phoneNumber || "";
        } else if (res.code !== 401) {
          Dialog.alert({title: "提示", message: res.returnMsg || "获取用户信息失败"});
        }
      } catch (err) {
        Dialog.alert({title: "错误", message: "网络异常，获取用户信息失败，请稍后重试"});
      }
    },

    //提交修改密码
    async onSubmit() {
      if (this.isSubmitting) return;

      // 步骤1：前置校验新密码长度
      const trimNewPwd = this.formData.newPassword.trim();
      if (trimNewPwd.length < 6 || trimNewPwd.length > 16) {
        Toast("新密码为6-16位字符，请重新输入");
        return;
      }

      // 步骤2：校验两次密码一致性
      const trimConfirmPwd = this.formData.confirmPassword.trim();
      if (trimNewPwd !== trimConfirmPwd) {
        Toast("两次输入的密码不一致，请重新输入");
        return;
      }

      try {
        this.isSubmitting = true;
        // 组装参数：提交去空格后的纯净密码
        const submitData = {
          phoneNumber: this.formData.phoneNumber,
          password: trimNewPwd
        };

        const res = await updatePassword(submitData);
        if (res.code === 200) {
          Toast.success("密码修改成功，请重新登录");
          // 延迟返回，也可替换为跳登录页：this.$router.push('/login')
          setTimeout(() => {
            this.$router.push('app_login');
          }, 1000);
        } else {
          Toast(res.returnMsg || "密码修改失败");
        }
      } catch (error) {
        Toast("网络异常，请稍后重试");
      } finally {
        this.isSubmitting = false;
      }
    },

    // 导航栏返回
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.h5-container {
  @media (min-width: 768px) {
    background-color: #1a1a1a;
  }
}
// 顶部导航栏：金色渐变
.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);

  ::v-deep {
    .van-icon-arrow-left, .van-nav-bar__text {
      color: #0f0f0f !important;
    }

    .van-nav-bar__title {
      color: #0f0f0f;
      font-weight: 500;
    }
  }
}

// 表单容器：间距、背景优化
.form-wrap {
  padding: 15px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 15px;
}

.pwd-tips {
  color: #f53f3f; // Vant标准危险色，符合移动端设计规范
  font-size: 12px; // 小字号，作为提示不抢视觉焦点
  text-align: center; // 居中显示，和按钮对齐
  line-height: 1.5; // 行高优化，避免文字拥挤
  font-weight: bold;
  padding-top: 15px;
  @media (min-width: 768px) {
    font-size: 20px;
    padding-top: 0;
  }
}

// 提交按钮：金色渐变，无边框
.submit-btn {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
  color: #000;
  font-weight: 500;
}

// 适配Vant表单样式
::v-deep .van-field {
  margin-bottom: 12px;
  --van-field-label-color: #333;
  --van-field-input-color: #333;
  --van-field-placeholder-color: #999;
}

// 只读手机号输入框样式
::v-deep .van-field--readonly .van-field__input {
  color: #666;
  background-color: #fafafa;
}
</style>